/* Auto generated file */
/* eslint-disable */
import { SVGSprite, type SVGSpriteProps } from '../svg/SVGBase';

const Tulu = ({ color = 'primary', aspectRatio = '507/137', ...rest}: SVGSpriteProps) =>
    <SVGSprite use="Tulu" aspectRatio={aspectRatio} color={color} {...rest} />;

export { Tulu, Tulu as default };
